import { Component, OnInit, AfterViewInit,ViewChild,ElementRef } from '@angular/core';
import { BsModalService ,BsModalRef } from 'ngx-bootstrap/modal';
import { WorkItemsService } from '@src/app/services/work-items/work-items.service';
import { HttpService } from '@src/app/services/common-http_service/http.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorPopupComponent } from '@templates/template2/error-popup/error-popup.component';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-verify-actions',
  templateUrl: './verify-actions.component.html',
  styleUrls: ['./verify-actions.component.scss']
})
export class VerifyActionsComponent implements OnInit,AfterViewInit {
  details: {};
  reason: string;
  modalRef: BsModalRef;
  actions_type: string;
  @ViewChild("NewEvent", {static: false}) newTemplate: ElementRef<any>;

  constructor(
    public bsModalRef: BsModalRef,
    public workItems: WorkItemsService,
    public modalService: BsModalService,
    private http: HttpService,
    public spinner : NgxSpinnerService
    ) {

  }

  ngOnInit() {
    // actions_type: type,
    // compnay_action:'merger',
    // id: this.companyActionId,
    // source_id: this.workItems.jobId
    if(this.details && Object.keys(this.details).length) {
      this.actions_type = this.details['actions_type'];
      console.log(this.actions_type);
      // if(this.details['actions_type'] === 'approved') {
      //   this.modalRef = this.modalService.show(this.acceptTemplate,{class:'modal-dialog-centered'})
      // } else {
      //   this.modalRef = this.modalService.show(this.rejectTemplate,{class:'modal-dialog-centered'})
      // }
    }
    
  }

  ngAfterViewInit() {
    
  }

  submit(form: any,value: string) {
    let body = {};
    let action = 'validate'
    if(form === 'reject' && !value) {
      return;
    }
    if(this.details['source_id']) {
      body['source_id'] = this.details['source_id'];
      body['source_type'] = 'WORK_ITEM';
    }
    if(form === 'reject' && value) {
      body['reject_reason'] = value;
      action = 'reject';
    } 
    this.spinner.show();
    this.http.update(`company-actions/${this.details['compnay_action']}`,`${this.details['id']}?action=${action}`,body).subscribe((data) => {
      this.workItems.cardName = '';
      this.workItems.jobCompleted({template: this.newTemplate});
      // this.spinner.hide();
      // this.actions_type = 'new_event'
      this.reason = '';
    },(error: HttpErrorResponse)=> {
      if(this.modalRef) this.modalRef.hide();
      this.spinner.hide();
      if(this.bsModalRef) this.bsModalRef.hide()
      if( error.status === 400 && 'data' in error.error && 'errors' in error.error.data) {
        const initialState = {
          errors: error.error.data.errors,
        };
        this.modalRef = this.modalService.show(ErrorPopupComponent, {initialState});
      }
    });

  }

}
